import { useEffect } from 'react';
import { useNotifications } from '@/contexts/notification-context';
import { setNotificationHandler } from '@/utils/deployment-detector';

export function DeploymentDetectionSetup() {
  const { addNotification } = useNotifications();

  useEffect(() => {
    // Set up the notification handler for deployment detection
    setNotificationHandler(addNotification);
  }, [addNotification]);

  // This component doesn't render anything
  return null;
} 